export default '/home/jenkins/agent/workspace/_glider_isomorphic-rollup_master/target/checkout/node_modules/.pnpm/sass@1.101.0/node_modules/sass'